<ng-container *ngIf="userStatus === 2">
  <h1>Registration in review</h1>
  <div>Your registration is in review. Please check your email for confirmation of your registration.</div>
</ng-container>

<ng-container *ngIf="userStatus === 3">
  <h1>Registration request received</h1>
  <div>
    The Biodiversity Offsets Program team has received your registration request. 
    Once your registration is accepted you’ll receive an email confirming that you can access the BCF Credit Portal.<br />    
  </div>
</ng-container>
